import { useContext, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { navbarContext } from '../Navbar/NavbarProvider';
import { adminNavItems, navItems } from './constants';
import { hasStoredAdminSession } from 'containers/Admin/adminSession';

function useHeader(title: string) {
  const location = useLocation();
  const { setHeaderTitle, setNavItems, setCollapsed } =
    useContext(navbarContext);

  useEffect(() => {
    const currentNavItems = hasStoredAdminSession() ? adminNavItems : navItems;

    setHeaderTitle(title);
    setNavItems(
      currentNavItems.map(el => ({
        ...el,
        selected: el.title === title || el.link === location.pathname,
      })),
    );

    return () => {
      setHeaderTitle('');
      setNavItems(navItems);
      setCollapsed(true);
    };
  }, [location.pathname, setHeaderTitle, setNavItems, title, setCollapsed]);
}

export default useHeader;
